import {Doughnut} from "components/Charts/doughnut";

export function TopCharts({url}) {

    return <>
        <Doughnut url={url}/>
    </>
}
